import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { injectIntl, FormattedMessage } from 'react-intl';
import FarePrice from './FarePrice';
import { CalendarPanel, CalendarGrid, Day } from './LowestFareFinder.styles';

const FareCalendar = ({ month, fares, direction, origin, destination, currency, selected, onSelect, minDate, maxDate, intl }) => {
  const first = moment(month, 'YYYY-MM').startOf('month');
  const available = fares.filter(
    (fare) =>
      fare &&
      Number.isFinite(fare.price) &&
      fare.price >= 0 &&
      fare.date.startsWith(month) &&
      fare.date >= moment().format('YYYY-MM-DD') &&
      (!minDate || fare.date >= minDate) &&
      (!maxDate || fare.date <= maxDate)
  );
  const lowest = Math.min(...available.map(({ price }) => price));
  const weekdays = Array.from({ length: 7 }, (_, i) =>
    intl.formatDate(moment().startOf('isoWeek').add(i, 'days').toDate(), { weekday: 'short' })
  );
  return (
    <CalendarPanel aria-label={intl.formatMessage({ id: `lowestFareFinder.${direction}` })}>
      <header>
        <strong>
          {origin} → {destination}
        </strong>
        <FormattedMessage id={`lowestFareFinder.${direction}`} />
      </header>
      <h2>{intl.formatDate(first.toDate(), { month: 'long', year: 'numeric' })}</h2>
      <CalendarGrid>
        {weekdays.map((day, i) => (
          <strong key={i}>{day}</strong>
        ))}
        {Array.from({ length: first.isoWeekday() - 1 }, (_, i) => (
          <div key={`blank-${i}`} />
        ))}
        {Array.from({ length: first.daysInMonth() }, (_, i) => {
          const date = first.clone().add(i, 'days').format('YYYY-MM-DD');
          const fare = available.find((entry) => entry.date === date);
          return (
            <Day
              key={date}
              type="button"
              disabled={!fare}
              $selected={selected?.date === date}
              aria-pressed={selected?.date === date}
              onClick={() => onSelect(fare)}
              aria-label={`${intl.formatDate(first.clone().add(i, 'days').toDate(), { day: 'numeric', month: 'long', year: 'numeric' })}, ${
                fare ? intl.formatNumber(fare.price, { style: 'currency', currency }) : '–'
              }`}
            >
              {i + 1}
              <FarePrice fare={fare} currency={currency} cheapest={fare?.price === lowest} />
            </Day>
          );
        })}
      </CalendarGrid>
    </CalendarPanel>
  );
};

FareCalendar.propTypes = {
  month: PropTypes.string.isRequired,
  fares: PropTypes.arrayOf(PropTypes.shape({ date: PropTypes.string, price: PropTypes.number })).isRequired,
  direction: PropTypes.string.isRequired,
  origin: PropTypes.string,
  destination: PropTypes.string,
  currency: PropTypes.string.isRequired,
  selected: PropTypes.shape({ date: PropTypes.string }),
  onSelect: PropTypes.func.isRequired,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  intl: PropTypes.object.isRequired
};

export default injectIntl(FareCalendar);
